import { render, staticRenderFns } from "./Step2ProductMapping.vue?vue&type=template&id=0fb2d286&scoped=true&"
import script from "./Step2ProductMapping.vue?vue&type=script&lang=js&"
export * from "./Step2ProductMapping.vue?vue&type=script&lang=js&"
import style0 from "./Step2ProductMapping.vue?vue&type=style&index=0&id=0fb2d286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2d286",
  null
  
)

export default component.exports